import { parseVideoLink } from '@/lib/video-links/parseVideoLink';
import type { SuggestionPlatform } from './types';

export interface NormalizedSuggestionUrl {
  platform: SuggestionPlatform;
  videoHash: string;
}

/**
 * Client mirror of the backend's `resolveTemplateSuggestionHash`. It exists so
 * the submit dialog can show the platform badge as the user pastes; the backend
 * remains authoritative for the value actually stored.
 */
export function normalizeSuggestionUrl(url: string): NormalizedSuggestionUrl | null {
  const trimmed = (url ?? '').trim();
  if (!trimmed) return null;

  let parsed: URL;
  try {
    parsed = new URL(trimmed);
  } catch {
    return null;
  }
  if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') return null;

  const { platform, videoId } = parseVideoLink(trimmed);
  const resolved: SuggestionPlatform = platform ?? 'other';

  if (platform && videoId) {
    return { platform: resolved, videoHash: `${platform}:${videoId}` };
  }

  const host = parsed.hostname.toLowerCase();
  const path = parsed.pathname.replace(/\/+$/, '');
  return { platform: resolved, videoHash: `other:${host}${path}` };
}
